/* eslint-disable */
import * as types from './graphql';



/**
 * Map of all GraphQL operations in the project.
 *
 * This map has several performance disadvantages:
 * 1. It is not tree-shakeable, so it will include all operations in the project.
 * 2. It is not minifiable, so the string of a GraphQL query will be multiple times inside the bundle.
 * 3. It does not support dead code elimination, so it will add unused operations.
 *
 * Therefore it is highly recommended to use the babel or swc plugin for production.
 * Learn more about it here: https://the-guild.dev/graphql/codegen/plugins/presets/preset-client#reducing-bundle-size
 */
type Documents = {
    "\n  mutation Login($username: String!, $password: String!) {\n    login(data: { username: $username, password: $password }) {\n      user {\n        id\n        username\n        email\n        organisationId\n        role\n        scope\n      }\n      token\n      shouldChangePassword\n    }\n  }\n": typeof types.LoginDocument,
    "\n  query User($userId: RoyID!) {\n    user(where: { id: $userId }) {\n      id\n      username\n    }\n  }\n": typeof types.UserDocument,
};
const documents: Documents = {
    "\n  mutation Login($username: String!, $password: String!) {\n    login(data: { username: $username, password: $password }) {\n      user {\n        id\n        username\n        email\n        organisationId\n        role\n        scope\n      }\n      token\n      shouldChangePassword\n    }\n  }\n": types.LoginDocument,
    "\n  query User($userId: RoyID!) {\n    user(where: { id: $userId }) {\n      id\n      username\n    }\n  }\n": types.UserDocument,
};

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function graphql(source: "\n  mutation Login($username: String!, $password: String!) {\n    login(data: { username: $username, password: $password }) {\n      user {\n        id\n        username\n        email\n        organisationId\n        role\n        scope\n      }\n      token\n      shouldChangePassword\n    }\n  }\n"): typeof import('./graphql').LoginDocument;
/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function graphql(source: "\n  query User($userId: RoyID!) {\n    user(where: { id: $userId }) {\n      id\n      username\n    }\n  }\n"): typeof import('./graphql').UserDocument;


export function graphql(source: string) {
  return (documents as any)[source] ?? {};
}
